// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4f57821e","498":"b54a0518","703":"55a11f67","787":"3545dc40"}[chunkId] + ".chunk.js";
};